export default __webpack_public_path__ + "static/media/logo_dmo.9476099d.svg";